"use strict";

exports.__esModule = true;
exports["default"] = Sdk;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Sdk(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M168.728 246.899l78.129 50.885v213.188L31.56 370.855V157.63l87.776 57.136v91.023l49.392 32.075v-90.965zm96.957 50.513v213.244L480.44 370.818V158.265L265.685 297.412zM393.187 90.269l-215.82 139.78 78.688 51.203 215.764-139.855-78.632-51.128zm-49.412-32.133L256 1 40.218 140.78l87.794 57.155L343.775 58.136z"
  }));
}